export const KNOWLEDGE_DATABASE_TABS = [
  'overview',
  'documents',
  'staging-documents',
  'crawls',
  'members',
  'settings',
] as const;

export type KnowledgeDatabaseTabId = (typeof KNOWLEDGE_DATABASE_TABS)[number];

export const DEFAULT_KNOWLEDGE_DATABASE_TAB: KnowledgeDatabaseTabId =
  'documents';

export function isKnowledgeDatabaseTabId(
  value: string | undefined,
): value is KnowledgeDatabaseTabId {
  return (
    value !== undefined &&
    (KNOWLEDGE_DATABASE_TABS as readonly string[]).includes(value)
  );
}

export function resolveKnowledgeDatabaseTabPath(
  databaseId: string,
  tabId: KnowledgeDatabaseTabId,
): string {
  return `/knowledge/${databaseId}/${tabId}`;
}
